import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import React, {useEffect} from "react";

const PieChart = ({ dataSkor, id }) => {
	useEffect(() => {
		var chart = am4core.create(id, am4charts.PieChart);
		let colorList = []
		for (let i in dataSkor) {
			const item = dataSkor[i]
			colorList.push(item.color)
		}
		chart.data = dataSkor;
		chart.radius = am4core.percent(95);


		// Add and configure Series
		var pieSeries = chart.series.push(new am4charts.PieSeries());
		pieSeries.dataFields.value = "value";
		pieSeries.dataFields.category = "key";
		pieSeries.alignLabels = false;

		let colorSet = new am4core.ColorSet();
		colorSet.list = colorList.map(function (
			color
		) {
			return new am4core.color(color);
		});
		pieSeries.colors = colorSet;
		pieSeries.fontSize = 12;

		function formatTextArray(text) {
			return text.replace(" ", "\n").replace(' ', '\n');
		}

		pieSeries.labels.template.adapter.add("textOutput", function (text, target) {
			var dataItem = target.dataItem;
			return ``;
		});

		pieSeries.slices.template.tooltipText = "{category}: ({value.percent}%)";
	}, [dataSkor, id]);


	return (
		<div>
			<div id={id}></div>
			<div style={{ display: 'flex', flexWrap: 'wrap', rowGap: '10px', columnGap: '10px' }}>
				{dataSkor.map((item, i) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} key={i}>
						<div style={{ width: '20px', height: '10px', borderRadius: '10px', backgroundColor: item.color }}></div>
						<div className="label-profile-name">{item.key} ({item.value})</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default PieChart;
